import React, { FC } from "react";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";

export const CircleExclamation: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => <FontAwesomeIcon icon={faCircleExclamation} {...props} />;
